import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { SocialMediaUpdateService } from '../../services';

export const fetchSocialMediaUpdate = createAsyncThunk(
    'socialMediaUpdate/fetchSocialMediaUpdate',
    async ({ id, file, title, slug }) => {
        const response = await SocialMediaUpdateService(id, file, title, slug)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const socialMediaUpdateSlice = createSlice({
    name: 'socialMediaUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSocialMediaUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSocialMediaUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSocialMediaUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default socialMediaUpdateSlice.reducer;
